import { SVGProps } from 'react'
import styled, { keyframes } from 'styled-components'

interface AnimatedPathProps extends SVGProps<SVGPathElement> {
  delay: number // Adicionando a propriedade delay
}

// Definição da animação de fade-in
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

// Estilizando os paths para incluir a animação com delay variável
export const AnimatedPath = styled.path<AnimatedPathProps>`
  opacity: 0;
  animation: ${fadeIn} 0.5s ease-in-out forwards;
  animation-delay: ${(props) => props.delay}s;
`
